import { NoUnitsType, TemperatureUnitsType, VolumeUnitsType } from "store/recipe/recipe.types";
import { WorkspaceDisplayMode, CalculationStatus, } from "./rs-workspace.types";
export const simulationPreviewDefaultSelectedVariables = [
    { value: "pH", unit: NoUnitsType.NoUnits },
    { value: "Temperature", unit: TemperatureUnitsType.C },
    { value: "Fill volume", unit: VolumeUnitsType.L },
];
const state = {
    isLocked: false,
    previewRequests: [],
    mode: WorkspaceDisplayMode.Scenario,
    state: {
        cellModels: [],
        recipes: [],
        resultSets: [],
        insights: [],
        simulations: [],
        processData: [],
        optimizations: [],
        calculation: { elements: [], saving: false, predictionTimeInProgress: false },
        calculationStatus: CalculationStatus.Incomplete,
    },
    calculationTabularResults: [],
    calculationSpaceviewerResults: [],
    calculationProcessDataViewerResults: [],
    calculationLineGraphResults: [],
    activeResultSetId: null,
    simulationDefaultName: null,
    simulationDialogOpen: false,
    currentSimulationId: null,
    currentVariantId: 0,
    renameVariantDialogOpen: false,
    insightDefaultName: null,
    insightDialogOpen: false,
    currentInsightId: null,
    optimizationDefaultName: null,
    optimizationDialogOpen: false,
    currentOptimizationId: null,
    simulationPreviews: {
        persisted: {},
        temporary: null,
    },
    optimizationPreviews: {
        persisted: {},
        temporary: null,
    },
    persistedInsightsData: [],
    lockedDialogData: null,
    resultsRecalculationDialogOpen: false,
    insightOperations: {
        comparisonOperations: [],
        evaluationOperations: [],
    },
    insightTransformations: [],
    insightOperationDescriptions: {
        evaluationDescriptions: null,
        comparisonDescriptions: null,
    },
    insightEssentialCombinations: null,
    insightErrors: null,
    activeResultElement: null,
    duplicateTargetResultSetId: null,
    createEntityFromResultElementDialogData: {
        elementId: null,
        sourceId: null,
    },
    shouldScrollToResultElement: false,
    isHighlightModeActive: false,
    highlightLeadingNode: null,
    resultIsFetching: false,
    unsavedChangesCalculationDialogOpen: false,
};
export default state;
